module.exports = __webpack_public_path__ + "assets/images/fruits_y.b27d9902.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/fruits_y.png
// module id = 713
// module chunks = 1